module.exports = __webpack_public_path__ + "static/media/feiyong.fe392153.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/feiyong.png
// module id = 1753
// module chunks = 0 1